<template>
  <div class="test_page_wrap">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  created() {
    
  },
  mounted() {
    
  },
}
</script>
<style lang="scss">
  .test_page_wrap{
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/examination/examinationPage.vue